import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';
import { handleResponseError } from '../../utils/helpers/network-error';
import { setTokens, getTokens, clearTokens, getCurrentLocation } from '../../utils/helpers/auth';

export const signIn = createAsyncThunk('auth.signIn', async ({
  formData, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const response = await api.auth.signInByEmail(formData);
    const { user, message } = await response.data;
    setTokens(response);
    onSuccess(message);
    return user;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});

export const logout = createAsyncThunk('auth.logout', async () => {
  try {
    await api.auth.logout();
    clearTokens();
  } catch (error) {
    clearTokens();
  }
});

export const checkAuth = createAsyncThunk('auth.checkAuth', async ({}, { rejectWithValue }) => {
  try {
    const { refreshToken } = getTokens();
    if (!refreshToken) {
      clearTokens();
      return rejectWithValue();
    }
    
    const response = await api.auth.refreshTokens(refreshToken);
    const { user } = await response.data;
    setTokens(response);
    return user;
  } catch (error) {
    return rejectWithValue();
  }
});
